import { useEffect, useState } from 'react'

/** Where a suspended customer is sent for help; the API names the same address. */
export const HELM_SUPPORT_EMAIL = 'support@systems.xtellar.co'

const EVENT = 'helm:customer-suspended'
let suspended = false

/**
 * Called when the API answers CUSTOMER_SUSPENDED: this customer login is locked
 * out of every customer page, so the shell swaps them all for one screen.
 */
export function reportCustomerSuspended() {
  if (suspended || typeof window === 'undefined') return
  suspended = true
  window.dispatchEvent(new Event(EVENT))
}

/** True once any request has come back CUSTOMER_SUSPENDED. */
export function useCustomerSuspended() {
  const [value, setValue] = useState(suspended)
  useEffect(() => {
    const onSuspended = () => setValue(true)
    window.addEventListener(EVENT, onSuspended)
    // A request may have failed between the first render and this effect.
    if (suspended) setValue(true)
    return () => window.removeEventListener(EVENT, onSuspended)
  }, [])
  return value
}
